/**
 * Nazwy jednostek w UI (MP / CID / QRF).
 * CID = Criminal Investigation Division; QRF — pełna nazwa małymi literami.
 */

export const UNIT_KEYS = ['mp', 'cid', 'qrf'];

/** Krótka etykieta (np. formularze admin) */
export const UNIT_LABEL_SHORT = {
  mp: 'Military Police',
  cid: 'Criminal Investigation Division',
  qrf: 'QRF',
};

/** Pasek nawigacji jednostki (czytelny skrót + pełna nazwa) */
export const UNIT_NAV_BADGE = {
  mp: 'Military Police',
  cid: 'CID · Criminal Investigation Division',
  qrf: 'QRF · quick reaction force',
};

/** Akronim przy pełnej nazwie */
export const UNIT_ACRONYM = {
  mp: 'MP',
  cid: 'CID',
  qrf: 'QRF',
};

/** Drugi wiersz / podtytuł */
export const UNIT_SUBLINE = {
  mp: null,
  cid: null,
  qrf: 'quick reaction force',
};

/** Tytuł karty na /jednostki (główny nagłówek) */
export const UNIT_SELECT_CARD = [
  {
    unit: 'mp',
    title: 'Military Police',
    desc: 'Rekrutacja, podania, skargi i panel użytkownika.',
    emoji: '🛡️',
  },
  {
    unit: 'cid',
    title: 'Criminal Investigation Division',
    desc: 'CID — osobny przepływ rekrutacji i panelu.',
    emoji: '🕵️',
  },
  {
    unit: 'qrf',
    title: 'QRF',
    desc: 'quick reaction force — ten sam układ co pozostałe jednostki.',
    emoji: '⚡',
  },
];

/** Nagłówki kolumn na /jednostki/overview */
export const UNITS_OVERVIEW_PANELS = [
  { unit: 'mp', heading: 'Military Police', sub: null, emoji: '🛡️' },
  { unit: 'cid', heading: 'Criminal Investigation Division', sub: 'CID', emoji: '🕵️' },
  { unit: 'qrf', heading: 'QRF', sub: 'quick reaction force', emoji: '⚡' },
];
